import React, { FunctionComponent } from 'react'
import { ContestantWithBio } from '../../../utils/interfaces'
import Text from '../../../components/Text'
import CompetitionCategories from '../CompetitionCategories'
import CompetitionDashboardContestants from '../CompetitionDashboardContestants'
import VotingOptions from '../../CompetitionPage/VotingRoundOptions'

export type TTab = {
  CONTESTANT_TAB: string,
  OPTIONS_TAB?: string,
  CATEGORIES_TAB: string
}

interface ITabContent {
  selectedTab: string,
  tabs: TTab,
  votingOptions: any,
  competitionTemplate?: number,
  deleteContestant: (contestantUsername: string) => void,
  evictContestant: (contestantUsername: string) => void,
  onClickContestantButton: () => void,
  saveContestant: (payload: ContestantWithBio) => Promise<void>,
  contestantLabel: string,
  savingContestant: boolean,
  contestants: ContestantWithBio[],
}

const TabContent: FunctionComponent<ITabContent> = React.memo(({
  tabs,
  selectedTab,
  votingOptions,
  ...rest
}) => {
  switch (selectedTab) {
    case tabs.CONTESTANT_TAB:
      return (
        <CompetitionDashboardContestants {...rest} />
      )
    case tabs.OPTIONS_TAB:
      return <VotingOptions {...votingOptions} />
    case tabs.CATEGORIES_TAB:
      return <CompetitionCategories />
    default:
      return <Text>Section under construction</Text>
  }
})

export default TabContent
